import AvatarPlaceholder from 'images/avatar-placeholder.png';
import { SyntheticEvent } from 'react';

// avatar links are signed and expire; a picture first shown after that falls back to the placeholder
export const showAvatarPlaceholder = ({ currentTarget }: SyntheticEvent<HTMLImageElement>) => {
  if (currentTarget.getAttribute('src') === AvatarPlaceholder) return;

  currentTarget.src = AvatarPlaceholder;
};
